module.exports = __webpack_public_path__ + "static/media/IntegrationSettingsEmpty.d9f6ebfb.png";